import { SET_TODO_CART, SET_TODO_PACKING_MODE } from 'src/actions/actionType'

const initialState = {
  packingMode: false,
  cart: null,
}

export default function TodoReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TODO_PACKING_MODE:
      return { ...state, packingMode: action.payload }
    case SET_TODO_CART:
      return { ...state, cart: action.payload }
    default:
      return state
  }
}
